<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="status" width="1085px" :close-on-click-modal="false"
      :before-close="resetFromDate">
      <span slot="title" class="dialog-title">工程信息</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px"
          hide-required-asterisk>
          <div class="form-title">工程基本信息</div>
          <div>
            <el-row>
              <el-col :span="12">
                <el-form-item v-if="UserInfo.adminStatus == 1" prop="companyId">
                  <span slot="label" style="color: #ff0000">公司</span>
                  <el-select ref="selection1" v-model="fromDate.companyId" :disabled="disabledflag" placeholder="请选择"
                    @change="
                      $nextTick(() => {
                        fromDate.companyName = $refs.selection1.selectedLabel;
                      })
                      ">
                    <el-option v-for="(item, index) in companyIdlist" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="name">
              <span slot="label" style="color: #ff0000">工程名称</span>
              <el-input v-model="fromDate.name" placeholder="请输入" :disabled="disabledflag" clearable
                @blur="nameBlurCheck"></el-input>
            </el-form-item>
            <el-form-item prop="expectedAmount" label-width="160px">
              <span slot="label" style="color: #ff0000">预估用砼量（万方）</span>
              <el-input v-model="fromDate.expectedAmount" style="width: 176px" placeholder="请输入" :disabled="disabledflag"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="fromDate.expectedAmount = $regExp.checkNum(fromDate.expectedAmount)"
                @blur="fromDate.expectedAmount = $regExp.blurCheckNum(fromDate.expectedAmount)"></el-input>
            </el-form-item>
            <el-form-item prop="roadworkType">
              <span slot="label" style="color: #ff0000">合同单位类型</span>
              <el-select v-model="fromDate.roadworkType" placeholder="请选择" :disabled="disabledflag" filterable clearable>
                <el-option v-for="(item, index) in roadworkTypeList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="businessTypeId">
              <span slot="label" style="color: #ff0000">业务类型</span>
              <el-select ref="businesName" v-model="fromDate.businessTypeId" :disabled="disabledflag" placeholder="请选择"
                @change="
                  $nextTick(() => {
                    fromDate.businesName = $refs.businesName.selectedLabel;
                  })
                  ">
                <el-option v-for="(item, index) in businessTypeIdList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item v-if="type == 1 || type == 0" prop="executePhase">
            <span slot="label" style="color: #ff0000">执行阶段</span>
            <el-select v-model="fromDate.executePhase" placeholder="请选择">
              <el-option label="委托交底" :value="1"></el-option>
              <el-option label="评估" :value="2"></el-option>
              <el-option label="投标" :value="3"></el-option>
              <el-option label="合同交底" :value="4"></el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item prop="typeId">
              <span slot="label" style="color: #ff0000">工程性质</span>
              <el-select ref="typeId" v-model="fromDate.typeId" :disabled="disabledflag" placeholder="请选择" @change="
                $nextTick(() => {
                  fromDate.type = $refs.typeId.selectedLabel;
                })
                ">
                <el-option v-for="(item, index) in typeIdList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item>
            <span slot="label">项目进度</span>
            <el-select
              ref="rateOfProgressId"
              v-model="fromDate.rateOfProgressId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.rateOfProgress = $refs.rateOfProgressId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in rateOfProgressIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item prop="startTime">
              <span slot="label" style="color: #ff0000">混凝土使用时间</span>
              <el-date-picker v-model="fromDate.startTime" :disabled="disabledflag" type="month" placeholder="选择月份"
                value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <el-form-item prop="placeTypeId">
              <span slot="label" style="color: #ff0000">销售处</span>
              <el-select ref="placeTypeId" v-model="fromDate.placeTypeId" :disabled="disabledflag" placeholder="请选择"
                @change="
                  $nextTick(() => {
                    fromDate.placeType = $refs.placeTypeId.selectedLabel;
                  })
                  ">
                <el-option v-for="(item, index) in saleDepList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="mortarServiceTime">
              <span slot="label" style="color: #ff0000">砂浆使用时间</span>
              <el-date-picker v-model="fromDate.mortarServiceTime" type="month" :disabled="disabledflag"
                placeholder="选择月份" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <el-form-item prop="concreteUndertaking">
              <span slot="label" style="color: #ff0000">我司混凝土</span>
              <el-input v-model="fromDate.concreteUndertaking" :disabled="disabledflag" placeholder="请输入" clearable
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="fromDate.concreteUndertaking = $regExp.checkNum(fromDate.concreteUndertaking)"
                @blur="fromDate.concreteUndertaking = $regExp.blurCheckNum(fromDate.concreteUndertaking)">
                <template slot="append">万方</template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item prop="acceptanceProbabilityId">
            <span slot="label" style="color: #ff0000">承接概率</span>
            <el-select
              ref="acceptanceProbabilityId"
              v-model="fromDate.acceptanceProbabilityId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.acceptanceProbability = $refs.acceptanceProbabilityId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in cjglList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
            <div>
              <el-form-item prop="mortarUndertaking">
                <span slot="label" style="color: #ff0000">砂浆</span>
                <el-input v-model="fromDate.mortarUndertaking" placeholder="请输入" :disabled="disabledflag" clearable
                  onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                  @input="fromDate.mortarUndertaking = $regExp.checkNum(fromDate.mortarUndertaking)"
                  @blur="fromDate.mortarUndertaking = $regExp.blurCheckNum(fromDate.mortarUndertaking)">
                  <template slot="append">万方</template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label" style="color: #ff0000">地理位置/最近供应站点</span>
                <div style="width: 227px">
                  <span v-if="fromDate.place" class="table_link" style="cursor: pointer" @click="selectMapFun()">{{
                    fromDate.place + "-" + (fromDate.latelyStationName || "") }}</span>
                  <span v-else class="table_link" style="cursor: pointer" @click="selectMapFun()">选择</span>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">运距</span>
                <el-input v-model="fromDate.haulDistance" disabled placeholder="请输入" clearable>
                  <template slot="append">km</template>
                </el-input>
              </el-form-item>
              <el-form-item v-if="fromDate.haulDistance > 30" prop="otherCarShop">
                <span slot="label" style="color: #ff0000">其他供应同行</span>
                <el-input v-model="fromDate.otherCarShop" :disabled="disabledflag" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label" style="color: #ff0000">施工单位</span>
                <el-select ref="contractSigningUnitId" v-model="fromDate.contractSigningUnitId" :disabled="disabledflag"
                  placeholder="请选择" filterable clearable @change="
                    $nextTick(() => {
                      fromDate.contractSigningUnit = $refs.contractSigningUnitId.selectedLabel;
                    })
                    ">
                  <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="roadworklInkman">
                <span slot="label" style="color: #ff0000">联系人</span>
                <el-input v-model="fromDate.roadworklInkman" :disabled="disabledflag" placeholder="请输入"
                  clearable></el-input>
              </el-form-item>
              <el-form-item prop="roadworkPhone">
                <span slot="label" style="color: #ff0000">电话</span>
                <el-input v-model="fromDate.roadworkPhone" type="Number" :disabled="disabledflag" placeholder="请输入"
                  clearable></el-input>
              </el-form-item>
              <el-form-item>
                <span slot="label" style="color: #ff0000">建设单位</span>
                <el-select ref="constructionUnitId" v-model="fromDate.constructionUnitId" :disabled="disabledflag"
                  placeholder="请选择" filterable clearable @change="
                    $nextTick(() => {
                      fromDate.constructionUnit = $refs.constructionUnitId.selectedLabel;
                    })
                    ">
                  <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="cuLinkman">
                <span slot="label" :style="fromDate.roadworkType == 1 ? 'color: #ff0000' : ''">联系人</span>
                <el-input v-model="fromDate.cuLinkman" placeholder="请输入" :disabled="disabledflag" clearable></el-input>
              </el-form-item>
              <el-form-item prop="cuPhone">
                <span slot="label" :style="fromDate.roadworkType == 1 ? 'color: #ff0000' : ''">电话</span>
                <el-input v-model="fromDate.cuPhone" placeholder="请输入" :disabled="disabledflag" type="Number"
                  clearable></el-input>
              </el-form-item>
              <el-form-item>
                <span slot="label" :style="fromDate.roadworkType == 3 ? 'color: #ff0000' : ''">小票打印单位</span>
                <el-select ref="otherUnitId" v-model="fromDate.otherUnitId" :disabled="disabledflag" placeholder="请选择"
                  filterable clearable @change="
                    $nextTick(() => {
                      fromDate.otherUnit = $refs.otherUnitId.selectedLabel;
                    })
                    ">
                  <el-option v-for="(item, index) in roadworkIdList" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <span slot="label" :style="fromDate.roadworkType == 3 ? 'color: #ff0000' : ''">联系人</span>
                <el-input v-model="fromDate.otherUnitLinkman" placeholder="请输入" :disabled="disabledflag"
                  clearable></el-input>
              </el-form-item>
              <el-form-item prop="otherUnitPhone">
                <span slot="label" :style="fromDate.roadworkType == 3 ? 'color: #ff0000' : ''">电话</span>
                <el-input v-model="fromDate.otherUnitPhone" placeholder="请输入" :disabled="disabledflag" type="Number"
                  clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="clientTypeId">
                <span slot="label" style="color: #ff0000">机会类型</span>
                <el-select ref="clientTypeId" v-model="fromDate.clientTypeId" :disabled="disabledflag" placeholder="请选择"
                  @change="
                    $nextTick(() => {
                      fromDate.clientType = $refs.clientTypeId.selectedLabel;
                    })
                    ">
                  <el-option v-for="(item, index) in clientTypeIdList" :key="index" :label="item.itemName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="orderGetTypeId">
              <span slot="label" style="color: #ff0000">订单获取方式</span>
              <el-select
                ref="orderGetTypeId"
                v-model="fromDate.orderGetTypeId"
                placeholder="请选择"
                @change="
                  $nextTick(() => {
                    fromDate.orderGetType = $refs.orderGetTypeId.selectedLabel;
                  })
                "
              >
                <el-option v-for="(item, index) in orderGetTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item>
                <span slot="label">行政区</span>
                <el-cascader ref="address" v-model="fromDate.administrativeDistricts0" :disabled="disabledflag"
                  style="width: 227px" :options="treeData" filterable
                  @change="administrativeDistrictsFun()"></el-cascader>
              </el-form-item>
              <el-form-item prop="region">
                <span slot="label">区域</span>
                <el-input v-model="fromDate.region" placeholder="请输入" :disabled="disabledflag" type="text"
                  clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label">管桩工程</span>
                <el-radio-group v-model="fromDate.whetherTubularColumn" :disabled="disabledflag" style="width: 227px">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="fromDate.whetherTubularColumn == 1">
                <span slot="label">管柱（米）</span>
                <el-input v-model="fromDate.tubularColumn" placeholder="请输入" :disabled="disabledflag"
                  onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                  @input="fromDate.tubularColumn = $regExp.checkNum(fromDate.tubularColumn)"
                  @blur="fromDate.tubularColumn = $regExp.blurCheckNum(fromDate.tubularColumn)"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label">装配式工程</span>
                <el-radio-group v-model="fromDate.whetherFabricated" :disabled="disabledflag" style="width: 227px">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="fromDate.whetherFabricated == 1">
                <span slot="label">装配式</span>
                <el-input v-model="fromDate.fabricated" placeholder="请输入" :disabled="disabledflag" clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <!-- <el-form-item v-if="UserInfo.adminStatus == 1" prop="createUserId"
                :rules="[{ required: true, message: '请选择负责人', trigger: 'change' }]" class="FZYdanWei">
                <span slot="label">负责人</span>
                <el-cascader ref="getCheckedNodes" v-model="fromDate.createUserId" style="width: 227px" 
                  :options="principalarr" :show-all-levels="false" :props="{ value: 'id', label: 'name' }"
                  :placeholder="createUserName"></el-cascader>
              </el-form-item> -->
              <el-form-item v-if="UserInfo.adminStatus == 1" prop="createUserId" class="FZYdanWei">
                <span slot="label">负责人</span>
                <el-cascader ref="getCheckedNodes" v-model="fromDate.createUserId" style="width: 227px"
                  :options="principalarr" :show-all-levels="false" :props="{ value: 'id', label: 'name' }"
                  :placeholder="createUserName"></el-cascader>
              </el-form-item>
            </div>
            <el-form-item>
              <span slot="label">备注</span>
              <el-input v-model="fromDate.remark" style="width: 920px" type="textarea" :disabled="disabledflag" :rows="5"
                resize="none" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <div v-if="fromDate.id">
            <div>
              <span class="titleTop">跟进记录</span>
            </div>
            <div class="link">
              <div class="linkOne"></div>
              <div class="linkTwo"></div>
            </div>
            <div class="timeline">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in followUpList" :key="index" color="#0bbd87">
                  <div class="line">
                    <div>
                      <span class="lineName">{{ item.createUserName }}</span>
                      <span>{{ item.createTime }} 更新:</span>
                      <el-tag v-if="item.whetherAdopt == 1" type="danger">已采纳</el-tag>
                      <el-tag v-else type="warning">待采纳</el-tag>
                    </div>
                    <div>
                      <el-button
                        v-if="item.whetherAdopt * 1 !== 1 && (UserInfo.userRealName == createUserName || UserInfo.adminStatus == 1)"
                        size="small" class="bottom_all" @click="updateFollowUpStatus(item)"> 采 纳 </el-button>
                    </div>
                  </div>
                  <div class="lineContent">{{ item.followUpMeesion }}</div>
                </el-timeline-item>
              </el-timeline>
              <el-form-item>
                <span slot="label">填写更新内容</span>
                <el-input v-model="fromDate.followUpMeesion" style="width: 920px" type="textarea" :rows="5" resize="none"
                  placeholder="请输入" clearable></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 电子围栏 -->
    <el-dialog v-dialogDrag :visible.sync="mapVisible" width="80%" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">地图选点</span>
      <div style="padding-bottom: 20px">
        <el-row>
          <el-col :span="17">
            <div class="amap-page-container">
              <el-amap-search-box ref="amapSearch" default="" class="search-box" :search-option="searchOption"
                :on-search-result="onSearchResult"></el-amap-search-box>
              <el-amap vid="amapDemo" :zoom="zoom" :events="events" :center="mapCenter" class="amap-demo"
                style="height: 550px">
                <el-amap-marker :position="markers.position" :events="markers.events"
                  :draggable="markers.draggable"></el-amap-marker>
              </el-amap>
              <div class="toolbar">position: {{ markers.position }} address: {{ address }}</div>
            </div>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-button class="bottom_all" style="margin-left: 24px; margin-bottom: 10px"
              @click="getStationToEngineeringDistanceData()">计 算</el-button>
            <el-table v-loading="StationToEngineeringDistanceLoad" :header-cell-style="{ background: '#f3f6f9' }"
              height="550px" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%"
              :data="StationToEngineeringDistanceData" tooltip-effect="dark">
              <el-table-column label="站点" width="auto" align="center" prop="stationName"></el-table-column>
              <el-table-column label="距离" width="auto" align="center" prop="distance"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="mapVisible = false">取 消</el-button>
        <el-button class="bottom_all" :disabled="StationToEngineeringDistanceData.length == 0" style="margin-left: 24px"
          @click="savepoint()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="compensate" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">提示</span>
      <div class="dialoginfo">
        <div style="position: relative;height:40px;">
          <div style="display: flex;justify-content: left;">
            <div style="">
              系统匹配到以下工程与你所登记工程类似：
            </div>
          </div>
        </div>
        <el-table ref="multipleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
          border stripe style="width: 100%" :data="compensateList" tooltip-effect="dark" @row-click='setradio'>
          <el-table-column align="center" label="选择">
            <template slot-scope="scope">
              <el-radio :value="searchradio" :label="JSON.stringify(scope.row)">{{ '' }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column align="center" label="工程名称" prop="name"></el-table-column>
          <el-table-column align="center" label="销售处" prop="placeType"></el-table-column>
          <el-table-column align="center" label="登记人" prop="createUserName"></el-table-column>
          <el-table-column align="center" label="匹配度" prop="matchingDegree">
            <template slot-scope="scope">
              <span>{{ (scope.row.matchingDegree * 100) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addFollowUpMession">添加跟进记录</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="compensate = false;">登记新工程</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import treeData from "@/views/platform/ICPS/basicConfig/address.js";
import { QueryOneByid, queryAllByCompanyId, getEngineeringDistance, updateFollowUpStatus, queryMatchingEng } from "@/api/internetSales/chanceManagement.js";
import { getcompany, orgUserTree, getDicType, getDicsType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  data() {
    let _this = this;
    var landlinePhone = (rule, value, callback) => {
      if (value && !this.$regExp.landlinePhoneReg(value)) {
        return callback(new Error("电话格式错误！"));
      } else if (!value && rule.required) {
        return callback(new Error("请输入电话！"));
      } else {
        callback()
      }
    };
    return {
      companyIdlist: [],
      treeData,
      UserInfo: "",
      principalarr: [],
      createUserName: "",
      TreeSelectStypeNumber: 0,
      roadworkIdList: [],
      roadworkTypeList: [
        { itemName: "建设单位", id: 1 },
        { itemName: "施工单位", id: 2 },
      ],
      fromDate: {
        roadworkType: "",
        typeId: "",
        createUserId: "",
        roadworkId: "",
        name: "",
        roadworklInkman: "",
        roadworkPhone: "",
        whetherFabricated: 0,
        whetherTubularColumn: 0,
        place: "",
        address: "逸都国际",
        longitude: 0,
        latitude: 0,
        region:'',
      },
      typeIdList: [],
      businessTypeIdList: [
        { itemName: "市场扩展", id: "1" },
        { itemName: "大营销（外协）", id: "5" },
        { itemName: "大营销（协外）", id: "6" },
        // { itemName: "非市场扩展", id: "2" },
        // { itemName: "自用业务", id: "3" },
        // { itemName: "往来业务", id: "4" },
      ],
      rateOfProgressIdList: [
        // { itemName: "立项规划阶段", id: "1" },
        // { itemName: "勘察设计阶段", id: "2" },
        // { itemName: "基础工程阶段", id: "3" },
        // { itemName: "主体结构阶段", id: "4" },
        // { itemName: "砌体工程阶段", id: "5" },
        // { itemName: "装饰工程阶段", id: "6" },
      ],
      clientTypeIdList: [],
      saleDepList: [],
      cjglList: [],
      rules: {
        companyId: [{ required: true, message: "请选择公司", trigger: "change" }],
        name: [{ required: true, message: "请输入工程名称", trigger: "change" }],
        startTime: [{ required: true, message: "请选择混凝土使用时间", trigger: "change" }],
        mortarServiceTime: [{ required: true, message: "请选择砂浆使用时间", trigger: "change" }],
        // expectedAmount: [{ required: true, message: "请输入预估用砼量", trigger: "change" }],
        tubularColumn: [{ required: true, message: "请输入管柱", trigger: "change" }],
        fabricated: [{ required: true, message: "请输入装配式", trigger: "change" }],
        contractSigningUnit: [{ required: true, message: "请选择施工单位", trigger: "change" }],
        constructionUnit: [{ required: true, message: "请输入建设单位", trigger: "change" }],
        roadworklInkman: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        // roadworkPhone:[{ required: true, message: "请输入电话", trigger: "blur" }],
        // cuLinkman: [{ required: true, message: "请输入联系人", trigger: "change" }],
        roadworkType: [{ required: true, message: "请选择合同单位", trigger: "change" }],
        otherCarShop: [{ required: true, message: "请输入其他供应同行", trigger: "change" }],
        businessTypeId: [{ required: true, message: "请选择业务类型", trigger: "change" }],
        executePhase: [{ required: true, message: "请选择执行阶段", trigger: "change" }],
        typeId: [{ required: true, message: "请选择工程性质", trigger: "change" }],
        clientTypeId: [{ required: true, message: "请选择机会类型", trigger: "change" }],
        orderGetTypeId: [{ required: true, message: "请选择订单获取方式", trigger: "change" }],
        placeTypeId: [{ required: true, message: "请选择销售处", trigger: "change" }],
        concreteUndertaking: [{ required: true, message: "请输入我司混凝土", trigger: "change" }],
        mortarUndertaking: [{ required: true, message: "请输入砂浆", trigger: "change" }],
        constructionUnitId: [{ required: true, message: "请选择建设单位", trigger: "change" }],
        contractSigningUnitId: [{ required: true, message: "请选择施工单位", trigger: "change" }],
        otherUnitId: [{ required: true, message: "请选择其他单位", trigger: "change" }],
        roadworkPhone: [{ required: true, message: "请输入电话", trigger: "blur", validator: landlinePhone, }],
        cuPhone: [{ validator: landlinePhone, trigger: "change" }],
        otherUnitPhone: [{ validator: landlinePhone, trigger: "change" }],
      },
      //地图
      mapVisible: false,
      zoom: 12,
      mapCenter: [104.065637, 30.657717],
      loaded: false,
      address: "逸都国际",
      events: {
        click: e => {
          _this.markers.position = [e.lnglat.lng, e.lnglat.lat];
          _this.getaddress(_this.markers.position);
        },
      },
      markers: {
        position: [1, 1],
        events: {
          dragend: e => {
            console.log(e);
            axios.get(`https://restapi.amap.com/v3/geocode/regeo?key=1ce84487b2aa51d790cac6e356046c5b&location=${e.lnglat.lng},${e.lnglat.lat}`).then(res => {
              this.address = res.data.regeocode.formatted_address;
            });
            _this.markers.position = [e.lnglat.lng, e.lnglat.lat];
          },
        },
        draggable: true,
      },
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      mapVisibleK: "",
      StationToEngineeringDistanceData: [],
      StationToEngineeringDistanceLoad: false,
      followUpList: [],

      //2023.6.21迭代工程登记
      compensate: false,
      compensateList: [],
      searchradio: '',
      disabledflag: false,
      orderGetTypeList:[],
    };
  },
  props: ["status", "sendData", "type", "executePhaseType"],
  watch: {
    async sendData() {
      if (this.sendData == "") {
        //工程管理点销售处登记
        this.fromDate = {};
        this.$set(this.fromDate, "expectedAmount", "");
        if (this.UserInfo.adminStatus == 3) {
          setTimeout(() => {
            this.fromDate.createUserId = this.UserInfo.userId;
            this.fromDate.createUserName = this.UserInfo.userRealName;
            this.fromDate.whetherFabricated = 0;
            this.fromDate.whetherTubularColumn = 0;
          }, 500);
        }
        return;
      }
      if (this.type == 0) {
        //工程管理点修改-销售
        // QueryOneByid({ id: this.sendData.id }).then(res => {
        //   this.fromDate = { ...this.fromDate, ...res.data };
        //   this.fromDate.administrativeDistricts0 = res.data.administrativeDistricts ? JSON.parse(res.data.administrativeDistricts)[2] : "";
        // this.createUserName = res.data.createUserName;
        // this.fromDate.createUserId = res.data.createUserId;
        // this.fromDate.whetherFabricated = res.data.whetherFabricated || 0;
        // this.fromDate.whetherTubularColumn = res.data.whetherTubularColumn || 0;
        // this.followUpList = res.data.followUpList || [];
        //   console.log(this.followUpList);
        // });
        this.fromDate = { ...this.fromDate, ...this.sendData };
        this.fromDate.administrativeDistricts0 = this.sendData.administrativeDistricts ? JSON.parse(this.sendData.administrativeDistricts) : "";
        this.createUserName = this.sendData.createUserName;
        this.fromDate.createUserId = this.sendData.createUserId;
        this.fromDate.whetherFabricated = this.sendData.whetherFabricated || 0;
        this.fromDate.whetherTubularColumn = this.sendData.whetherTubularColumn || 0;
        this.followUpList = this.sendData.followUpList || [];
      } else if (this.type == 1) {
        //销售机会点登记，
        console.log(this.sendData);
        this.fromDate = { ...this.fromDate, ...this.sendData, roadworkId: this.sendData.contractUnitId, clientTypeId: this.sendData.chanceTypeId };
        console.log(this.fromDate);
        this.followUpList = this.fromDate.followUpList || [];
        this.fromDate.id = "";
        this.fromDate.opportunityId = this.sendData.id;
        this.fromDate.administrativeDistricts0 = JSON.parse(this.sendData.administrativeDistricts);
        this.createUserName = this.sendData.createUserName;
        this.fromDate.whetherFabricated = this.sendData.whetherFabricated || 0;
        this.fromDate.whetherTubularColumn = this.sendData.whetherTubularColumn || 0;
      }
    },
    status() {
      // 重置表单
      if (this.sendData == "") {
        this.$data.fromDate = this.$options.data().fromDate;
        this.$set(this.fromDate, "expectedAmount", "");
      }
    },
  },
  async created() {
    getDicType({ code: "Orderacquisitionmethod" }).then(res => {
      this.orderGetTypeList = res.data.items;
    });
    getDicType({ code: "EngineeringNature" }).then(res => {
      this.typeIdList = res.data.items;
    });
    getDicType({ code: "customerType" }).then(res => {
      this.clientTypeIdList = res.data.items;
    });
    getDicType({ code: "ProjectProgress" }).then(res => {
      this.rateOfProgressIdList = res.data.items;
    });
    getDicType({ code: "CJGL" }).then(res => {
      this.cjglList = res.data.items;
    });
    getDicsType({ codes: "EngineeringNature,contractType,MATname,castingType,shutdownLogo, placeDon, recordFixedPostition, market" }).then(res => {
      if (res.code == 1001 && res) {
        this.saleDepList = res.data.placeDon.items;
      }
    });
    queryAllByCompanyId().then(res => {
      this.roadworkIdList = res.data;
    });
    this.UserInfo = getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        this.companyIdlist = res.data;
      });
    }
    this.principalarr = await orgUserTree('',1);
    this.fromDate.whetherFabricated = 0;
    this.fromDate.whetherTubularColumn = 0;
    this.treeData.forEach(v => {
      v.children.forEach(res => {
        res.children.forEach(res2 => {
          delete res2.children;
        });
      });
    });
  },
  methods: {
    //按钮：添加工程记录
    addFollowUpMession() {
      if (this.searchradio) {
        QueryOneByid({ id: JSON.parse(this.searchradio).id }).then(res => {
          this.fromDate = { ...this.fromDate, ...res.data };
          this.fromDate.administrativeDistricts0 = res.data.administrativeDistricts ? JSON.parse(res.data.administrativeDistricts) : "";
          this.createUserName = res.data.createUserName;
          this.fromDate.createUserId = res.data.createUserId;
          this.fromDate.whetherFabricated = res.data.whetherFabricated || 0;
          this.fromDate.whetherTubularColumn = res.data.whetherTubularColumn || 0;
          this.followUpList = res.data.followUpList || [];
          console.log(this.followUpList);
          this.compensate = false
          this.disabledflag = true
        });
      } else {
        this.$message.warning('请选择工程进行添加记录哟~')
      }
    },
    /**搜索条件单选选中*/
    setradio(data) {
      this.searchradio = JSON.stringify(data)
    },
    //工程名称填写后验证历史工程是否重复
    nameBlurCheck(e) {
      if (!this.executePhaseType) {
        queryMatchingEng({ engName: e.target.value }).then(res => {
          if (res.code == 1001) {
            this.compensateList = res.data
            if (this.compensateList.length > 0) {
              this.compensate = true
            }
          }
        })
      }
    },
    //采纳
    updateFollowUpStatus(item) {
      let data = {
        whetherAdopt: 1,
        id: item.id
      }
      updateFollowUpStatus(data).then(res => {
        if (res.code == 1001) {
          this.$message.success('采纳成功')
          item.whetherAdopt = 1
        }
      })
    },
    //销售机会 登记为相同工程时，选择跟进工程
    setFromData(data) {
      if (data) {
        QueryOneByid({ id: data.id }).then(res => {
          this.fromDate = { ...this.fromDate, ...res.data };
          this.fromDate.administrativeDistricts0 = JSON.parse(res.data.administrativeDistricts);
          this.createUserName = res.data.createUserName;
          this.fromDate.createUserId = "";
          this.fromDate.whetherFabricated = res.data.whetherFabricated || 0;
          this.fromDate.whetherTubularColumn = res.data.whetherTubularColumn || 0;
          this.followUpList = res.data.followUpList || [];
        });
      } else {
        this.$data.fromDate = this.$options.data().fromDate;
        this.$set(this.fromDate, "expectedAmount", "");
      }
    },
    //地图开始
    getStationToEngineeringDistanceData() {
      this.StationToEngineeringDistanceLoad = true;
      this.StationToEngineeringDistanceData = [];
      let params1 = {
        longitude: this.markers.position[0],
        latitude: this.markers.position[1],
      }
      let params2 = {
        longitude: this.markers.position[0],
        latitude: this.markers.position[1],
        companyId: this.fromDate.companyId
      }
      getEngineeringDistance(this.UserInfo.adminStatus == 1 ? params2 : params1)
        .then(res => {
          if (res.code == 1001) {
            res.data.sort((a, b) => {
              return a.distance - b.distance;
            });
            this.StationToEngineeringDistanceData = res.data;
          }
          this.StationToEngineeringDistanceLoad = false;
        })
        .catch(() => {
          this.StationToEngineeringDistanceLoad = false;
        });
    },
    savepoint() {
      if (this.markers.position.length == 0) {
        this.$message({
          message: "请选择经纬度坐标",
          type: "warning",
        });
        return;
      }
      this.fromDate.longitude = this.markers.position[0];
      this.fromDate.latitude = this.markers.position[1];
      this.fromDate.address = this.address;
      this.fromDate.place = this.address;
      this.fromDate.latelyStationName = this.StationToEngineeringDistanceData[0].stationName;
      this.fromDate.latelyStationId = this.StationToEngineeringDistanceData[0].stationId;
      this.fromDate.haulDistance = this.StationToEngineeringDistanceData[0].distance;
      this.fromDate.distanceList = this.StationToEngineeringDistanceData;
      this.mapVisible = false;
    },
    selectMapFun() {
      this.mapVisible = true;
      if (this.$refs.amapSearch) {
        this.$refs.amapSearch.keyword = "";
        this.$refs.amapSearch.tips = [];
      }
      if (this.fromDate.longitude) {
        this.mapCenter = [this.fromDate.longitude, this.fromDate.latitude];
        console.log(this.mapCenter);
      } else {
        setTimeout(() => {
          this.mapCenter = [104.065637, 30.657717];
        }, 10);
      }
      this.address = this.fromDate.address;
      let obj = [
        {
          name: this.fromDate.address,
          lng: this.fromDate.longitude,
          lat: this.fromDate.latitude,
        },
      ];
      this.onSearchResult(obj);
      if (this.fromDate.longitude !== 0) {
        this.getStationToEngineeringDistanceData();
      } else {
        this.StationToEngineeringDistanceData = [];
      }
    },
    /**逆向编码*/
    getaddress(lnglat) {
      let _this = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            _this.address = result.regeocode.formattedAddress;
          }
        });
      });
    },
    /*地图*/
    onSearchResult(pois) {
      console.log(this.searchOption);
      let _this = this;
      if (pois.length > 0) {
        _this.address = pois[0].name;
        _this.markers.position = [pois[0].lng, pois[0].lat];
        _this.mapCenter = [pois[0].lng, pois[0].lat];
      }
    },
    //地图结束
    administrativeDistrictsFun() {
      this.fromDate.administrativeDistricts = JSON.stringify(this.fromDate.administrativeDistricts0);
      this.fromDate.administrativeDistrictsName = this.$refs.address.getCheckedNodes()[0].pathLabels.join("-");
      this.$forceUpdate();
    },
    cz() {
      if (this.$refs.reffromDate) {
        this.$nextTick(() => {
          this.$refs.reffromDate.clearValidate();
        })
      }
    },
    copy(list) {
      let str = JSON.stringify(list);
      return JSON.parse(str);
    },
    resetFromDate() {
      let _this = this;
      _this.$emit("close");
    },
    submitFromDate() {
      let _this = this;
      if (this.fromDate.name == this.fromDate.roadworkId) {
        this.$message.warning("工程名称和合同单位不能重复！");
        return;
      }
      if (!this.fromDate.place || !this.fromDate.address || (!this.fromDate.longitude && this.fromDate.longitude !== 0)) {
        this.$message.warning("请选择地理位置/最近供应站点");
        return;
      }
      if (!this.fromDate.contractSigningUnitId) {
        this.$message.warning("请选择施工单位及填写联系人、电话！");
        return;
      }
      if (!this.fromDate.constructionUnitId) {
        this.$message.warning("请选择建设单位！");
        return;
      }
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.fromDate.businesName = _this.businessTypeIdList.find(function (obj) {
            return obj.id == _this.fromDate.businessTypeId;
          }).itemName;
          if (_this.fromDate.roadworkType == 1) {
            if (!_this.fromDate.cuPhone || !_this.fromDate.cuLinkman || !_this.fromDate.constructionUnitId) {
              return this.$message.warning("请选择建设单位及填写联系人、电话！");
            }
            _this.fromDate.roadwork = _this.fromDate.constructionUnit;
            _this.fromDate.roadworkId = _this.fromDate.constructionUnitId;
          } else if (_this.fromDate.roadworkType == 2) {
            _this.fromDate.roadwork = _this.fromDate.contractSigningUnit;
            _this.fromDate.roadworkId = _this.fromDate.contractSigningUnitId;
          } else if (_this.fromDate.roadworkType == 3) {
            if (!_this.fromDate.otherUnitPhone || !_this.fromDate.otherUnitLinkman || !_this.fromDate.otherUnitId) {
              return this.$message.warning("请选择其他单位及填写联系人、电话！");
            }
            _this.fromDate.roadwork = _this.fromDate.otherUnit;
            _this.fromDate.roadworkId = _this.fromDate.otherUnitId;
          } else {
            _this.fromDate.roadwork = _this.fromDate.otherUnit;
            _this.fromDate.roadworkId = _this.fromDate.otherUnitId;
          }
          if (this.UserInfo.adminStatus == 3 && !this.fromDate.companyId) {
            //非admin默认使用当前账号信息里面的公司组织用户[并且是修改才赋值]
            this.fromDate.companyId = this.UserInfo.companyId;
            this.fromDate.company = this.UserInfo.companyName;
            this.fromDate.organizationId = this.UserInfo.organizationId;
            this.fromDate.createUserId = this.UserInfo.userId;
            this.fromDate.createUserName = this.UserInfo.userRealName;
          } else if (this.UserInfo.adminStatus == 1) {
            //admin选择使用负责人里面的
            // console.log(this.$refs.getCheckedNodes.getCheckedNodes()[0] !== null)
            if (this.$refs.getCheckedNodes.getCheckedNodes()[0] !== null) {
              let size = this.$refs.getCheckedNodes.getCheckedNodes()[0].path.length;
              this.fromDate.companyId = this.$refs.getCheckedNodes.getCheckedNodes()[0].path[0];
              this.fromDate.company = this.$refs.getCheckedNodes.getCheckedNodes()[0].pathLabels[0];
              this.fromDate.organizationId = this.fromDate.createUserId[size - 2];
              this.fromDate.createUserId = this.fromDate.createUserId[this.fromDate.createUserId.length - 1];
              _this.fromDate.createUserName = this.$refs.getCheckedNodes.getCheckedNodes()[0].label;
            }
          }
          if (_this.sendData) {
            _this.fromDate.winningBidders = _this.sendData.winningBidders;
            _this.fromDate.dealPrice = _this.sendData.dealPrice;
          }
          delete _this.fromDate.assessStatus
          delete _this.fromDate.bidStatus
          delete _this.fromDate.contractStatus
          delete _this.fromDate.entrustStatus
          _this.disabledflag = false;
          _this.$emit("sumbit", _this.fromDate);
          // setTimeout(() => {
          //   this.$data.fromDate = this.$options.data().fromDate;
          //   this.$refs.reffromDate.clearValidate();
          // }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    TreeSelectStypeFun() {
      if (this.TreeSelectStypeNumber === 0) {
        this.TreeSelectStypeNumber = 1;
        setTimeout(() => {
          const dom = document.body.lastChild;
          dom.style.zIndex = "10000";
        }, 1000);
      }
    },
    initSet() {
      this.$nextTick(() => {
        this.fromDate = this.$options.data().fromDate;
        this.$refs.reffromDate.clearValidate();
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.form-readonly {
  pointer-events: none;
}

.el-input,
.el-select {
  width: 227px;
}

.dialoginfo {
  padding: 0;
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
}

.titleTop {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 0px;
  color: #000000;
  opacity: 1;
}

.link {
  display: flex;
  margin-top: 8px;
}

.linkOne {
  width: 260px;
  height: 0px;
  border: 2px solid #00a754;
  opacity: 1;
  background-color: #00a754;
  margin-top: 18px;
}

.linkTwo {
  width: 1500px;
  height: 0px;
  border: 1px solid #00a754;
  background-color: #00a754;
  opacity: 1;
  margin-top: 19px;
}

.timeline {
  margin-top: 30px;
  margin-left: 8%;
}

.line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lineContent {
  // width: 32px;
  margin-top: 19px;
  font-size: 16px;
  font-family: PingFang SC;
  color: #000000;
  opacity: 1;
}

.lineName {
  font-size: 14px;
  color: #2170ca;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0px;
  color: #2170ca;
  margin-right: 15px;
}
</style>
<style lang="scss" scoped>
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}

.toolbar {
  padding-top: 10px;
}

.amap-page-container {
  position: relative;
  height: 570px;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.mapbutton {
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
}

.mapbutton:hover {
  border-color: $bg_color;
  cursor: pointer;
}

.amap-demo {
  height: 400px;
}
</style>